import { createContext } from "react";

const LogoContext = createContext(null);

export default LogoContext;
